// extracted by mini-css-extract-plugin
export default {"filter":"QuestionList_filter__trBPl","fadeIn":"QuestionList_fadeIn__vqWBe","tblheader":"QuestionList_tblheader__UFUqW","btn":"QuestionList_btn__n2dO1"};